(function ($) {
  Drupal.behaviors.FacebookCommentsV1 = {
    attach: function (context) {
      var $fbCommentsBtn = $('.facebook-comments__refresh-button', context);

      $(window).on('load', function (e) {
        $fbCommentsBtn.removeClass('hidden');
      });

      $(document).on('facebookComments:refresh', function (e) {
        var $comments = $('.fb-comments');
        var $commentsHeight = $comments.height();

        if (typeof FB !== 'undefined') {
          setTimeout(function () {
            $comments.css('min-height', $commentsHeight);
            FB.XFBML.parse();
          }, 50);
        }
      });

      $fbCommentsBtn.click(function (e) {
        $(document).trigger('facebookComments:refresh');
      });
    }
  };
})(jQuery);
